import { UsageDistribution } from './UsageDistribution';
import { ComplexCharts } from '../shared/ComplexCharts';
import type { Tool } from '@/features/traceability/type/Tool';

type GlobalPerformanceChartsProps = {
  tools: Tool[];
  selectedReference: string;
  isLoading: boolean;
};

export function GlobalPerformanceCharts({
  tools,
  selectedReference,
  isLoading,
}: GlobalPerformanceChartsProps) {
  // Filter tools for selected reference
  const referenceTools = tools.filter((tool) => tool.reference === selectedReference);

  if (!selectedReference) {
    return null;
  }

  return (
    <div className="space-y-6">
      {/* Section 1: Usage Distribution */}
      <UsageDistribution tools={referenceTools} isLoading={isLoading} />

      {/* Section 2: Complex Charts */}
      <ComplexCharts tools={referenceTools} isLoading={isLoading} mode="analytics" />
    </div>
  );
}
